import { render, staticRenderFns } from "./historicalExp.vue?vue&type=template&id=748860a6&scoped=true&"
import script from "./historicalExp.vue?vue&type=script&lang=js&"
export * from "./historicalExp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748860a6",
  null
  
)

export default component.exports